module.exports = __webpack_public_path__ + "static/media/am-questionmark.7001863a.svg";